import {useEffect, useRef, useState} from "react";
import {API_CHECK_TIME, API_SUCCESS, API_TIMEOUT} from "./types";
import {chatApi} from "./features/chat/chatApi";
import {useNavigate} from "react-router-dom";
import {DenyPopover} from "./DenyPopover";
import IconX from "./assets/x.svg?react";
import {useTranslation} from "react-i18next";

const SessionExpired = () => {
    const {t} = useTranslation();
    const [retryAttempts, setRetryAttempts] = useState(0);
    const checkSessionTimerRef = useRef<NodeJS.Timeout | null>(null);
    const [sessionExpired, setSessionExpired] = useState(false);
    const [getLoginStatus, {isLoading}] = chatApi.endpoints.pong.useLazyQuery();

    const startCheckSessionTimer = () => {
        if (checkSessionTimerRef.current) {
            clearTimeout(checkSessionTimerRef.current);
        }

        checkSessionTimerRef.current = setTimeout(() => {
            getLoginStatus().then((r) => {
                if (r.isError) {
                    setSessionExpired(true);
                }
            });
        }, API_CHECK_TIME);
    };

    const handleSetSessionExpired = () => {
        setSessionExpired(true);
    };

    const triggerLogin = () => {
        setSessionExpired(false);
        setRetryAttempts(retryAttempts + 1);

        if (retryAttempts > 3) {
            return;
        }

        window.location.href =
            "/auth/dib_login?returnUrl=" +
            encodeURIComponent(
                window.location.pathname + window.location.search
            );
    };

    useEffect(() => {
        document.addEventListener(API_TIMEOUT, handleSetSessionExpired);
        document.addEventListener(API_SUCCESS, startCheckSessionTimer);

        return () => {
            document.removeEventListener(API_TIMEOUT, handleSetSessionExpired);
            document.removeEventListener(API_SUCCESS, startCheckSessionTimer);
        };
    }, []);

    useEffect(() => {
        if (!sessionExpired) {
            return;
        }

        // If the user is not focused on the tab, wait for them to focus on the tab before triggering login
        if (document.hidden) {
            window.addEventListener("focus", triggerLogin);

            return () => {
                window.removeEventListener("focus", triggerLogin);
            };
            // If the user is focused on the tab, trigger login immediately
        } else {
            triggerLogin();
        }
    }, [sessionExpired]);

    if (retryAttempts > 3) {
        return (
            <DenyPopover
                icon={<IconX />}
                title={t("forbidden.title")}
                description={t("forbidden.description")}
            />
        );
    }

    return <></>;
};

export default SessionExpired;
